// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invitation-mail_wrapper__k9VTM {
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 12px;
}

.invitation-mail_circle__nR9qj {
  width: 30px;
  height: 30px;
  background-color: var(--secondary-background-color);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.invitation-mail_email-content__Wz9f5 {
  display: grid;
  grid-template-columns: 1fr auto;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.invitation-mail_email__r\\+kOL {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 12px;
}

.invitation-mail_email-label__ezINg {
  max-width: 380px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.invitation-mail_dropdown__Dhn68 {
  border: none;
  max-width: 100px;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 5px;
  display: flex;
  gap: 8px;
}

.invitation-mail_close__tc6Ej {
  cursor: pointer;
  padding: 2px;
}

.invitation-mail_circle-1__bt-OZ {
  background-color: #f0c7c7;
}

.invitation-mail_circle-2__G4jfE {
  background-color: #cfc7f0;
}

.invitation-mail_circle-3__qI2hM {
  background-color: #c7f0e0;
}

.invitation-mail_circle-4__QIlRp {
  background-color: #f7ffc4;
}
`, "",{"version":3,"sources":["webpack://./src/components/invitation-mail.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mDAAmD;EACnD,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".wrapper {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  align-items: center;\n  gap: 12px;\n}\n\n.circle {\n  width: 30px;\n  height: 30px;\n  background-color: var(--secondary-background-color);\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.email-content {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n}\n\n.email {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  align-items: center;\n  gap: 12px;\n}\n\n.email-label {\n  max-width: 380px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dropdown {\n  border: none;\n  max-width: 100px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  padding: 5px;\n  display: flex;\n  gap: 8px;\n}\n\n.close {\n  cursor: pointer;\n  padding: 2px;\n}\n\n.circle-1 {\n  background-color: #f0c7c7;\n}\n\n.circle-2 {\n  background-color: #cfc7f0;\n}\n\n.circle-3 {\n  background-color: #c7f0e0;\n}\n\n.circle-4 {\n  background-color: #f7ffc4;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `invitation-mail_wrapper__k9VTM`,
	"circle": `invitation-mail_circle__nR9qj`,
	"email-content": `invitation-mail_email-content__Wz9f5`,
	"email": `invitation-mail_email__r+kOL`,
	"email-label": `invitation-mail_email-label__ezINg`,
	"dropdown": `invitation-mail_dropdown__Dhn68`,
	"close": `invitation-mail_close__tc6Ej`,
	"circle-1": `invitation-mail_circle-1__bt-OZ`,
	"circle-2": `invitation-mail_circle-2__G4jfE`,
	"circle-3": `invitation-mail_circle-3__qI2hM`,
	"circle-4": `invitation-mail_circle-4__QIlRp`
};
export default ___CSS_LOADER_EXPORT___;
